import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Config } from 'app/config.const';
import { IContatto } from 'app/model/contatto';
import { ISubject } from 'app/model/soggetto';
import { flatMap, map, publishLast, refCount, take } from 'rxjs/operators';
import { RESTArray } from '../angular-rest';

@Injectable()
export class ContattiUtenti extends RESTArray<IContatto> {

	constructor($http: HttpClient) {
		super(
			$http, 
			`${Config.baseURL}/contatti`
		);
	}

	update(body: IContatto) {
		const obs = this.pipe(
			take(1),
			flatMap(arr => {
				const newArr = arr.slice();
				return this.$http.post(
						`${this.uri}/${body.id}`,  
						body, 
						{ responseType: "text" }
					).pipe(
						map(() => {
							for(var i in newArr) {
								if(newArr[i].id === body.id) {
									newArr[i] = body;
									return newArr;
								}
							}

							throw new Error("Impossibile aggiornare un'entità non esistente");

						})
					);
			}),
			publishLast(),
			refCount()

		);
		
		// Aggiungo la richiesta alla pipeline!
		this.generator.next(obs);

		// Questa sottoscrizione mi assicura che la chiamata non venga cancellata
		// per via di un unsubscribe lato switch
		return obs.toPromise();
	}
}

@Injectable()
export class Contatti extends RESTArray<ISubject> {
	constructor($http: HttpClient) {
		super(
			$http,
			`${Config.baseURL}/cerca/contatti`
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/model/contatti.ts